var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAlone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.458,187.633a8.887,8.887,0,0,0-.8-3.025,9.084,9.084,0,0,0-5.054-4.653,5.263,5.263,0,1,0-6.281,0,8.979,8.979,0,0,0-5.855,7.678,0.8,0.8,0,0,0,.207.61,0.793,0.793,0,0,0,.59.257h0a0.8,0.8,0,0,0,.8-0.735,7.425,7.425,0,0,1,14.793,0,0.8,0.8,0,0,0,.8.735h0a0.792,0.792,0,0,0,.585-0.255A0.81,0.81,0,0,0,38.458,187.633Zm-6.4-14.464a3.6,3.6,0,0,1,1.067,2.7,3.663,3.663,0,0,1-6.249,2.457,3.6,3.6,0,0,1-1.067-2.7,3.662,3.662,0,0,1,3.538-3.527c0.041,0,.082,0,0.122,0A3.634,3.634,0,0,1,32.056,173.169Z",
    transform: "translate(-20.469 -170.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAlone);
export default __webpack_public_path__ + "static/media/user-alone.dc5a6242.svg";
export { ForwardRef as ReactComponent };